import { Button, Tooltip } from '@fluentui/react-components';
import { FileTypeIcon } from '@fluentui/react-icons-file-type';
import { useState } from 'react';
import { exportToExcel, type ExcelExportColumn } from '../utils/excelExport';

interface ExcelExportButtonProps<T> {
    items: T[];
    columns: ExcelExportColumn<T>[];
    fileName: string;
    sheetName?: string;
    tooltip?: string;
}

function ExcelExportButton<T>({
    items,
    columns,
    fileName,
    sheetName,
    tooltip = 'Export to Excel',
}: ExcelExportButtonProps<T>) {
    const [isExporting, setIsExporting] = useState(false);

    const handleExport = async () => {
        setIsExporting(true);
        try {
            await exportToExcel(items, columns, fileName, sheetName);
        } catch (error) {
            console.error('Error exporting to Excel:', error);
        } finally {
            setIsExporting(false);
        }
    };

    return (
        <Tooltip content={tooltip} relationship="label">
            <Button
                appearance="subtle"
                icon={<FileTypeIcon extension="xlsx" size={24} />}
                onClick={handleExport}
                disabled={items.length === 0 || isExporting}
            />
        </Tooltip>
    );
}

export default ExcelExportButton;
